<template>
  <modal
    :value="value"
    max-width="800"
    :title="$t('message.integrations.message.recordsNotSent')"
    content-class="integration-failed-attempts-modal"
    @input="emitInput"
  >
    <div class="container flex-col">
      <div class="actions-section">
        <div class="actions-wrapper flex-space-between">
          <Button
            class="flat"
            :label="$t('message.integrations.message.discardRecords')"
            @click="deleteFailedAttempts"
          />
          <Button
            class="btn-primary"
            :label="$t('message.integrations.message.resendRecords')"
            @click="resendFailedAttempts"
          />
        </div>
      </div>
      <list :headers="headers" :list="failedAttemptsList" @load="load">
        <template slot="default" slot-scope="slotProps">
          <integration-failed-attempts-list-item
            :item="slotProps.item"
          ></integration-failed-attempts-list-item>
        </template>
      </list>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/generic/Modal";
import List from "@components/generic/list/List.vue";
import Button from "@components/generic/button/Button.vue";
import IntegrationFailedAttemptsListItem from "./list/item/IntegrationFailedAttemptsListItem.vue";
import EventBus from "@packages/event-bus";

export default {
  components: {
    Modal,
    List,
    Button,
    IntegrationFailedAttemptsListItem,
  },
  data() {
    return {
      show: false,
      infiniteId: +new Date(),
      failedAttemptsList: [],
    };
  },

  props: {
    integration: {
      type: Object,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },

  watch: {},

  computed: {
    headers() {
      return [
        {
          text: this.$t("message.integrations.message.registrationDate"),
          value: "registryDate",
          sortable: false,
        },
        {
          text: this.$t("message.spots.message.spot"),
          value: "local",
          sortable: false,
        },
        {
          text: this.$t("message.integrations.message.content"),
          value: "content",
          sortable: false,
        },
        {
          text: this.$t("message.integrations.message.error"),
          value: "error",
          sortable: false,
        },
      ];
    },
  },

  methods: {
    async load($state) {
      try {
        const { content } =
          await this.$api.integrationManagement.listIntegrationFailedAttempts({
            id: this.integration.id,
          });

        this.failedAttemptsList = content;

        $state.complete();
      } catch (error) {
        console.log(error);
        $state.complete();
      }
    },
    reload() {
      this.infiniteId++;
    },
    async deleteFailedAttempts() {
      try {
        EventBus.$emit("SHOW_SPINNER");
        await this.$api.integrationManagement.deleteIntegrationFailedAttempts({
          id: this.integration.id,
        });
        this.closeModal();
        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t("message.successMessages.message.recordsDiscarded"),
        });
        this.$emit("reload");
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    async resendFailedAttempts() {
      try {
        EventBus.$emit("SHOW_SPINNER");
        await this.$api.integrationManagement.resendIntegrationFailedAttempts({
          id: this.integration.id,
        });
        this.closeModal();
        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t(
            "message.successMessages.message.recordsBeingResent"
          ),
        });
        this.$emit("reload");
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    closeModal() {
      this.emitInput(false);
    },
    emitInput(value) {
      this.$emit("input", value);
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.integration-failed-attempts-modal {
  .container {
    gap: 28px;

    .actions-section {
      display: flex;
      justify-content: flex-end;

      .actions-wrapper {
        gap: 12px;
      }
    }
  }
}
</style>
